import { TCheckoutLayout } from "../../core/types/Checkout"

const sxMainPaperDefault = {
  width: "100%",
  borderRadius: {
    xs: "0px",
    sm: "8px",
  },
  pb: 2,
}

const sxMainPaperLayout5 = {
  width: "100%",
  backgroundColor: "transparent",
  borderRadius: {
    xs: "0px",
    sm: "8px",
  },
  pb: 2,
}

const sxMainPaperLayout6 = {
  width: "100%",
  backgroundColor: "#f8f8f8",
  borderRadius: "8px",
  pb: 2,
  border: "1px solid #DCDDDE",
}

const sxMainPaperLayout7 = {
  width: "100%",
  backgroundColor: "#ffffff",
  borderRadius: {
    xs: "0px",
    md: "8px",
  },
  pb: 2,
  border: {
    xs: "0px",
    md: "1px solid #DCDDDE",
  },
}

const sxMainPaperLayout8 = {
  width: "100%",
  backgroundColor: "#fafafa",
  borderRadius: {
    xs: "0px",
    md: "8px",
  },
  pb: 2,
  border: {
    xs: "0px",
    md: "0px solid #DCDDDE",
  },
}

const sxSecondaryPaperDefault = {
  width: "100%",
  borderRadius: "8px",
  mt: 1.5,
}

const sxSecondaryPaperLayout5 = {
  width: "100%",
  borderRadius: {
    xs: "0px",
    sm: "8px",
  },
  mt: 1,
}

const sxSecondaryPaperLayout6 = {
  width: "100%",
  borderRadius: "8px",
  mt: 1,
  backgroundColor: "#f8f8f8",
}

const sxSecondaryPaperLayout7 = {
  width: "100%",
  borderRadius: "8px",
  mt: 1,
  backgroundColor: "#ffffff",
}

const sxSecondaryPaperLayout8 = {
  width: "100%",
  borderRadius: "8px",
  mt: 1,
  backgroundColor: "#fafafa",
}

export const CheckoutLayoutStyles = {
  [TCheckoutLayout.None]: {
    sxMainPaper: sxMainPaperDefault,
    sxSecondaryPaper: sxSecondaryPaperDefault,
  },
  [TCheckoutLayout.Default]: {
    sxMainPaper: sxMainPaperDefault,
    sxSecondaryPaper: sxSecondaryPaperDefault,
  },
  [TCheckoutLayout.Layout2]: {
    sxMainPaper: sxMainPaperDefault,
    sxSecondaryPaper: sxSecondaryPaperDefault,
  },
  [TCheckoutLayout.Layout3]: {
    sxMainPaper: sxMainPaperDefault,
    sxSecondaryPaper: sxSecondaryPaperDefault,
  },
  [TCheckoutLayout.Layout4]: {
    sxMainPaper: sxMainPaperDefault,
    sxSecondaryPaper: sxSecondaryPaperDefault,
  },
  [TCheckoutLayout.Layout5]: {
    sxMainPaper: sxMainPaperLayout5,
    sxSecondaryPaper: sxSecondaryPaperLayout5,
  },
  [TCheckoutLayout.Layout6]: {
    sxMainPaper: sxMainPaperLayout6,
    sxSecondaryPaper: sxSecondaryPaperLayout6,
  },
  [TCheckoutLayout.Layout7]: {
    sxMainPaper: sxMainPaperLayout7,
    sxSecondaryPaper: sxSecondaryPaperLayout7,
  },
  [TCheckoutLayout.Layout8]: {
    sxMainPaper: sxMainPaperLayout8,
    sxSecondaryPaper: sxSecondaryPaperLayout8,
  },
}
